import React from "react";

import PropTypes from "prop-types";
import { FOLDERS } from "shared/graphql/queries";
import { FOLDERS_GROUP_BY, REPARATION_REQUEST_STATUS } from "utils/constants";
import useLoadMoreQuery from "utils/hooks/useLoadMoreQuery";

import View from "./View";

const Component = ({ setActiveStep, onChange }) => {
  const { query, onLoadMore } = useLoadMoreQuery({
    queryName: FOLDERS,
    type: "folders",
    filter: {
      where: {
        state: REPARATION_REQUEST_STATUS.CLOSED,
        groupBy: FOLDERS_GROUP_BY.PRODUCT,
      },
    },
    fetchPolicy: "no-cache",
  });

  return (
    <View
      setActiveStep={setActiveStep}
      onLoadMore={onLoadMore}
      query={query}
      onChange={onChange}
    />
  );
};

Component.propTypes = {
  onChange: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
